module.exports = __webpack_public_path__ + "img/img7.31a75b25.png";